import Vue from 'vue';
import VueRouter from 'vue-router';

// 注册 VueRouter
Vue.use(VueRouter);
import index from '../components/index.vue';
import login from '../views/login.vue';
// 定义路由
const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: login, meta: { title: '代理商-登录' },}, // 根路径重定向到登录页面
  {
    path: '/index',
    name: 'index',
    meta: { requiresAuth: true , title: '代理商端' },
    component: index, // 懒加载组件
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('@/views/About.vue'),
  // },
  // 404兜底路由，未匹配到的路径全部重定向到登录页
  { path: '*', redirect: '/login' },
];

// 创建路由实例
const router = new VueRouter({
  mode: 'history', // 使用 HTML5 history 模式
  base: process.env.BASE_URL, // 基础路径
  routes,
});
router.beforeEach((to, from, next) => {
  to.meta.title && (document.title = to.meta.title);
  // 路由保护：需要登录的页面必须有agentUserInfo
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const agentUserInfo = localStorage.getItem('agentUserInfo');
    if (!agentUserInfo) {
      // 未登录，强制替换跳转到登录页，防止白屏和历史记录问题
      next({ path: '/login', replace: true });
    } else {
      next();
    }
  } else {
    next();
  }
});
// 导出路由实例
export default router;
